import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ServiceWorkerModule } from '@angular/service-worker';

import { AppRoutingModule } from './app-routing.module';
import { AuthModule } from '@shared/modules/auth/auth.module';
import { HomepageModule } from './homepage/homepage.module';
import { SharedModule } from './shared/shared.module';

import { AppComponent } from './app.component';
import { CurrencySelectorComponent } from '@shared/components/currency-selector/currency-selector.component';
import { ErrorInterceptor } from '@shared/interceptors/error.interceptor';
import { HeaderMenuComponent } from '@shared/components/header-menu-cr/header-menu.component';
import { LocationsMenuComponent } from '@shared/components/locations-menu/locations-menu.component';
import { PageHeaderComponent } from '@shared/components/page-header-cr/page-header.component';
import { PageFooterComponent } from '@shared/components/page-footer-cr/page-footer.component';
import { TokenInterceptor } from '@shared/interceptors/token.interceptor';
import { environment } from '../environments/environment';

@NgModule({
  bootstrap: [
    AppComponent
  ],
  declarations: [
    AppComponent,
    CurrencySelectorComponent,
    HeaderMenuComponent,
    LocationsMenuComponent,
    PageHeaderComponent,
    PageFooterComponent
  ],
  imports: [
    AppRoutingModule,
    AuthModule,
    BrowserAnimationsModule,
    BrowserModule,
    FontAwesomeModule,
    FormsModule,
    HomepageModule,
    NgbModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),
    SharedModule
  ],
  providers: [
    provideClientHydration(),
    { provide: LOCALE_ID, useValue: 'en' },
    provideHttpClient(withFetch(), withInterceptors([ErrorInterceptor, TokenInterceptor]))
  ]
})
export class AppModule { }
